import React from 'react';
import ReactDOM from 'react-dom/client'; // Import the `createRoot` from 'react-dom/client'
import App from './App';
// import './index.css'; // optional
// import reportWebVitals from './reportWebVitals'; // optional

// Create a root element and render the app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 
    <App />

);

// reportWebVitals(); // optional
